import type {Route} from '../lib/router/routes.js';

const modelRoutes: Route[] = [
  {
    path: '',
    import: () => import('../pages/models/_index/route.js'),
    options: {index: true},
  },
  {
    path: 'new',
    import: () => import('../pages/models/new/route.js'),
  },
  {
    path: ':modelId/edit',
    import: () => import('../pages/models/$modelId.edit/route.js'),
  },
];

export const chromeless: Route[] = [
  {
    path: '/user_invitations/:token',
    import: () => import('../pages/user_invitations/$token/route.js'),
  },
  {
    path: '/admin/hylo',
    import: () => import('../pages/admin/hylo/route.js'),
    options: {
      index: true,
    },
  },
];

export const routes: Route[] = [
  {
    path: '/identities',
    import: () => import('../pages/identities/route.js'),
    children: [
      {
        path: '',
        import: () => import('../pages/identities/_index/route.js'),
        options: {
          index: true,
        },
      },
    ],
  },
  {
    path: '/identities/:identityId',
    import: () => import('../pages/identities.$identityId/route.js'),
    children: [
      {
        path: 'summary',
        import: () =>
          import('../pages/identities.$identityId/summary/route.js'),
      },
      {
        path: 'sources',
        import: () =>
          import('../pages/identities.$identityId/sources/_index/route.js'),
      },
      {
        path: 'match_config',
        import: () =>
          import('../pages/identities.$identityId/match_config/route.js'),
        children: [
          {
            path: '',
            import: () =>
              import('../pages/identities.$identityId/match_config/_index/route.js'),
            options: {
              index: true,
            },
          },
          {
            path: 'pii_precedence',
            import: () =>
              import('../pages/identities.$identityId/match_config/pii_precedence/route.js'),
          },
          {
            path: 'match_rules',
            import: () =>
              import('../pages/identities.$identityId/match_config/match_rules/route.js'),
          },
        ],
      },
      {
        path: 'settings',
        import: () =>
          import('../pages/identities.$identityId/settings/_index/route.js'),
      },
    ],
  },
  {
    path: '/v2/studio',
    import: () => import('../pages/studio/route.js'),
    children: [
      {
        path: '',
        import: () => import('../pages/studio/_index/route.js'),
        options: {
          index: true,
        },
      },
      {
        path: 'chat',
        import: () => import('../pages/studio/chat/route.js'),
        children: [
          {
            path: '',
            import: () => import('../pages/studio/chat/_index/route.js'),
            options: {
              index: true,
            },
          },
          {
            path: ':conversationId',
            import: () =>
              import('../pages/studio/chat.$conversationId/route.js'),
          },
        ],
      },
      {
        path: 'contexts',
        import: () => import('../pages/studio/contexts/route.js'),
      },
      {
        path: 'tasks',
        import: () => import('../pages/studio/tasks/route.js'),
      },
      {
        path: 'tasks/:taskId',
        import: () => import('../pages/studio/tasks.$taskId/route.js'),
      },
    ],
  },
  {
    path: '/v2/context-graph-explorer',
    import: () => import('../pages/context_graph_explorer/route.js'),
    options: {
      index: true,
    },
  },
  {
    path: '/audiences',
    import: () => import('../pages/audiences/route.js'),
    children: [
      {
        path: '',
        import: () => import('../pages/audiences/_index/route.js'),
        options: {
          index: true,
        },
      },
    ],
  },
  {
    path: '/v2/review_audiences',
    import: () => import('../pages/review_audiences/route.js'),
    children: [
      {
        path: '',
        import: () => import('../pages/review_audiences/_index/route.js'),
        options: {
          index: true,
        },
      },
    ],
  },
  {
    path: '/v2/journeys',
    import: () => import('../pages/journeys/route.js'),
    children: [
      {
        path: '',
        import: () => import('../pages/journeys/_index/route.js'),
        options: {
          index: true,
        },
      },
    ],
  },
  {
    path: '/v2',
    import: () =>
      import(
        /* webpackChunkName: "journey_builder_v2" */
        '../pages/journey_builder/route.js'
      ),
    children: [
      {
        path: 'journeys/new',
        import: () => import('../pages/journey_builder/path.js'),
      },
      {
        path: 'dataset_groups/:datasetGroupId/journeys/:journeyId/edit',
        import: () => import('../pages/journey_builder/path.js'),
      },
    ],
  },
  {
    path: '/signal_routes',
    import: () => import('../pages/signal_routes/route.js'),
    children: [
      {
        path: '',
        import: () => import('../pages/signal_routes/_index/route.js'),
        options: {
          index: true,
        },
      },
      {
        path: 'new',
        import: () => import('../pages/signal_routes/new/route.js'),
      },
      {
        path: ':signalRouteId/edit',
        import: () =>
          import('../pages/signal_routes/$signalRouteId.edit/route.js'),
      },
    ],
  },
  {
    path: '/queue_events/new',
    import: () => import('../pages/queue_events/new/route.js'),
  },
  {
    path: '/queue_events/:queueEventId/edit',
    import: () => import('../pages/queue_events/$queueEventId.edit/route.js'),
  },
  {
    path: '/v2/models',
    import: () => import('../pages/models/route.js'),
    children: modelRoutes,
  },
  {
    path: '/v2/dataset_groups/:datasetGroupId/audiences/*',
    import: () => import('../pages/audience_builder/route.js'),
  },
  {
    path: '/models',
    import: () => import('../pages/models/route.js'),
    children: modelRoutes,
  },
  {
    path: '/dataset_groups/new',
    import: () => import('../pages/data_manager/route.js'),
  },
  {
    path: '/dataset_groups/:datasetGroupId/edit',
    import: () => import('../pages/data_manager/route.js'),
  },
  {
    path: '/home',
    import: () => import('../pages/home/route.js'),
  },
  {
    path: '/destination_platforms',
    import: () => import('../pages/destinations/route.js'),
  },
  {
    path: '/teams/:teamId/destination_platforms/:destinationConnectionId/edit',
    import: () =>
      import('../pages/destinations/$destinationConnectionId.edit/route.js'),
  },
  {
    path: '/import_sources',
    import: () => import('../pages/import_sources/route.js'),
  },
  {
    path: '/source_connections',
    import: () => import('../pages/source_connections/route.js'),
  },
  {
    path: '/metrics',
    import: () => import('../pages/metrics/route.js'),
    children: [
      {
        path: '',
        import: () => import('../pages/metrics/_index/route.js'),
        options: {
          index: true,
        },
      },
      {
        path: 'new',
        import: () => import('../pages/metrics/new/route.js'),
      },
      {
        path: ':metricId',
        import: () => import('../pages/metrics/$metricId/route.js'),
      },
    ],
  },
  {
    path: '/organization',
    import: () => import('../pages/organization/route.js'),
    options: {
      index: true,
    },
  },
  {
    path: '/user',
    import: () => import('../pages/user/route.js'),
    options: {
      index: true,
    },
  },
  {
    path: '/admin/debug',
    import: () => import('../pages/admin_debug/_index/route.js'),
    options: {
      index: true,
    },
  },
  // TEMPORARY: Remove once React SPA migration is complete.
  {
    path: '/admin/react_pages',
    import: () => import('../pages/admin/react_pages/route.js'),
    options: {
      index: true,
    },
  },
  {
    path: '/content-library',
    import: () => import('../pages/content_library/route.js'),
    children: [
      {
        path: '',
        import: () => import('../pages/content_library/_index/route.js'),
        options: {
          index: true,
        },
      },
      {
        path: 'email/new',
        import: () => import('../pages/content_library/email.new/route.js'),
      },
      {
        path: 'email/:contentId/edit',
        import: () =>
          import('../pages/content_library/email.$contentId.edit/route.js'),
      },
    ],
  },
  {
    path: '/channels',
    import: () => import('../pages/channels/route.js'),
    options: {
      index: true,
    },
  },
  {
    path: '/governance',
    import: () => import('../pages/governance_rules/route.js'),
    children: [
      {
        path: '',
        import: () => import('../pages/governance_rules/_index/route.js'),
        options: {index: true},
      },
      {
        path: 'rules',
        import: () => import('../pages/governance_rules/rules/route.js'),
      },
    ],
  },
];
